import React from "react";

export default function AuthLayout({ icon: Icon, title, subtitle, footer, children }) {
  return (
    <div className="min-h-screen flex items-center justify-center bg-background px-4">
      <div className="w-full max-w-md">
        <div className="text-center mb-10">
          <div className="inline-flex items-center justify-center w-14 h-14 rounded-2xl bg-primary mb-4">
            <Icon className="w-7 h-7 text-primary-foreground" aria-hidden="true" />
          </div>
          <h1 className="text-3xl font-bold tracking-tight text-foreground">{title}</h1>
          {subtitle && <p className="text-muted-foreground mt-2">{subtitle}</p>}
        </div>
        <div className="bg-card rounded-2xl shadow-sm border border-border p-8">
          {children}
        </div>
        {footer && (
          <p className="text-center text-sm text-muted-foreground mt-6">{footer}</p>
        )}
        <div className="mt-6 text-center">
          <div className="text-[11px] text-muted-foreground">Drill Log Pro by 2DudesTech PTY LTD</div>
          <div className="mt-2 flex justify-center gap-3 text-[11px] text-muted-foreground">
            <a href="/legal#privacy" className="hover:underline">Privacy Policy</a>
            <span aria-hidden="true">·</span>
            <a href="/legal#terms" className="hover:underline">Terms of Service</a>
            <span aria-hidden="true">·</span>
            <a href="/tools/coming-soon-support" className="hover:underline">Support</a>
          </div>
        </div>
      </div>
    </div>
  );
}
